<div class="modal-header">
    <h4 class="modal-title fw-bold"><span jhiTranslate="germplasm-progenitors-modal.edit.header">Edit pedigree</span></h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
            (click)="clear()">
    </button>
</div>
<div class="container">
	<div class="modal-body">
		<span class="fw-bold" jhiTranslate="germplasm-progenitors-modal.header">Edit the germplasm progenitors</span>
		<form name="form" #f="ngForm" class="pt-3">
			<div class="mb-3 row required">
				<label for="breedingMethod" class="col-sm-4 col-form-label fw-bold" jhiTranslate="germplasm-progenitors-modal.breeding.method"></label>
				<div class="col-sm-8">
					<jhi-breeding-methods-select [(value)]="breedingMethodSelectedId"
												 [selectWidth]="'100%'"
												 [showAllMethodTypesOption]="false"
												 [showDerivativeMethodTypesOption]="true"
												 [showGenerativeMethodTypesOption]="true"
												 [showFavoritesCheckbox]="false"
												 (onMethodChanged)="onMethodChanged($event)"
												 (breedingMethodFilterTypeValueChange)="breedingMethodOptionChanged($event)"></jhi-breeding-methods-select>
				</div>
			</div>
			<div *ngIf="!isMutation()" class="mb-3 row">
				<label for="femaleparent" class="col-sm-4 col-form-label fw-bold">
					<span>{{ (isGenerative ? (AllowMultipleFemale() ? 'germplasm-progenitors-modal.female.parents' : 'germplasm-progenitors-modal.female.parent') : 'germplasm-progenitors-modal.group.source') | translate}}</span><br/>
					<span class="fst-italic small" jhiTranslate="germplasm-progenitors-modal.parent.subtext"></span>
				</label>
                <div class="col-sm-8">
                    <div class="input-group">
                        <input *ngIf="!AllowMultipleFemale()" jhiApplyOnlyNumbers [allowComma]="false" type="text" class="form-control" name="femaleparent" id="femaleparent" [(ngModel)]="femaleParent" #femaleparent placeholder="{{'germplasm-progenitors-modal.enter-gid' | translate}}"/>
                    <input *ngIf="AllowMultipleFemale()" jhiApplyOnlyNumbers [allowComma]="true" type="text" class="form-control" name="femaleparent" id="femaleparent" [(ngModel)]="femaleParent" #femaleparent placeholder="{{'germplasm-progenitors-modal.enter-gids' | translate}}"/>
                        <button class="btn btn-outline-secondary" type="button" jhiTranslate="germplasm-progenitors-modal.search" (click)="openGermplasmSelector(AllowMultipleFemale(), 'female')">Search</button>
                    </div>
                </div>
			</div>
			<div *ngIf="!isMutation()" class="mb-3 row">
				<label for="maleparent" class="col-sm-4 col-form-label fw-bold">
					<span>{{ (isGenerative ? (AllowMultipleMale() ? 'germplasm-progenitors-modal.male.parents' : 'germplasm-progenitors-modal.male.parent') : 'germplasm-progenitors-modal.immediate.source') | translate}}</span><br/>
					<span class="fst-italic small" jhiTranslate="germplasm-progenitors-modal.parent.subtext"></span></label>
                <div class="col-sm-8">
                    <div class="input-group">
                        <input *ngIf="!AllowMultipleMale()" jhiApplyOnlyNumbers [allowComma]="false" type="text" class="form-control" name="maleparent" id="maleparent" [(ngModel)]="maleParent" #maleparent placeholder="{{'germplasm-progenitors-modal.enter-gid' | translate}}"/>
                        <input *ngIf="AllowMultipleMale()" jhiApplyOnlyNumbers [allowComma]="true" type="text" class="form-control" name="maleparent" id="maleparent" [(ngModel)]="maleParent" #maleparent placeholder="{{'germplasm-progenitors-modal.enter-gids' | translate}}"/>
                        <button class="btn btn-outline-secondary" type="button" jhiTranslate="germplasm-progenitors-modal.search" (click)="openGermplasmSelector(AllowMultipleMale(), 'male')">Search</button>
                    </div>
                </div>
			</div>
			<div *ngIf="isMutation()" class="mb-3 row">
				<label for="origin" class="col-sm-4 col-form-label fw-bold">
					<span jhiTranslate="germplasm-progenitors-modal.origin"></span><br/>
					<span class="fst-italic small" jhiTranslate="germplasm-progenitors-modal.parent.subtext"></span>
				</label>
                <div class="col-sm-8">
                    <div class="input-group">
                        <input jhiApplyOnlyNumbers [allowComma]="false" type="text" class="form-control" name="origin" id="origin" [(ngModel)]="femaleParent" #origin="ngModel" placeholder="{{'germplasm-progenitors-modal.enter-gid' | translate}}"/>
                        <button class="btn btn-outline-secondary" type="button" jhiTranslate="germplasm-progenitors-modal.search" (click)="openGermplasmSelector(false, 'female')">Search</button>
                    </div>
                </div>
			</div>
		</form>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="clear()">
			<span class="fa fa-ban"></span>&nbsp;<span jhiTranslate="cancel"></span>
		</button>
		<button (click)="save()" [disabled]="!isFormValid(f)" class="btn btn-primary" [disabled]="isLoading">
			<span *ngIf="isLoading" class="throbber throbber-btn"></span>
			<span class="fa fa-save"></span>&nbsp;<span jhiTranslate="update"></span>
		</button>
	</div>
</div>
